import i18n from '@/plugins/i18n';

export type AccessFailure = 'subscriptionRequired' | 'forbidden' | 'unauthorized' | 'unavailable';

interface FeatureError {
  code?: string;
  response?: { status?: number; data?: { code?: string; error?: string; message?: string } };
}

export function getAccessFailure(error: unknown): AccessFailure | null {
  const err = error as FeatureError | undefined;
  const code = err?.response?.data?.code || err?.code;
  const legacy = err?.response?.data?.error;
  if (code === 'SUBSCRIPTION_REQUIRED' || legacy === 'subscription_required'
    || legacy === 'User does not have an active subscription') return 'subscriptionRequired';
  if (code === 'SUBSCRIPTION_UNAVAILABLE'
    || legacy === 'Subscription verification temporarily unavailable') return 'unavailable';
  if (err?.response?.status === 401 || code === 'UNAUTHORIZED') return 'unauthorized';
  if (err?.response?.status === 403 || code === 'FORBIDDEN') return 'forbidden';
  if ((err?.response?.status || 0) >= 500
    || ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(code || '')) return 'unavailable';
  return null;
}

export function getFeatureErrorMessage(error: unknown): string {
  const failure = getAccessFailure(error);
  const err = error as FeatureError | undefined;
  const validation = err?.response?.data?.code || err?.response?.data?.error;
  const key = failure || ({
    mobile_field_required: 'mobileRequired',
    duplicate_slug: 'duplicateSlug',
  } as Record<string, string>)[validation || ''];
  if (key) return i18n.global.t(`paidFeatures.errors.${key}`);
  // Preserve actionable validation details supplied by the domain API.
  // Access errors and server failures above always use translated copy.
  if ([400, 409, 422].includes(err?.response?.status || 0)
    && typeof err?.response?.data?.message === 'string') return err.response.data.message;
  return i18n.global.t('paidFeatures.errors.generic');
}
